export * from './src/interface';
export * from './src/status.error';
export * from './src/mock.service';
export * from './src/mock.interceptor';
export * from './mock.config';
export * from './mock.module';
